import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Dialog } from '@refera/ui-web'
import { InfoCircle as InfoCircleIcon, Danger as DangerIcon } from '@refera/ui-icons'

const VARIANT_DIALOG = {
  info: { Icon: InfoCircleIcon, type: 'info' },
  warning: { Icon: DangerIcon, type: 'warning' },
}

const ConfirmationModal = ({
  isOpen,
  handleClose,
  description,
  cancelButtonText,
  confirmButtonText,
  handleConfirmClick,
  handleDeniedClick,
  disabled,
  variant,
}) => {
  const onCancel = useCallback(() => {
    if (handleDeniedClick) {
      handleDeniedClick()
      return
    }
    handleClose()
  }, [handleClose, handleDeniedClick])

  const onApprove = useCallback(() => {
    if (disabled) return
    handleConfirmClick()
  }, [disabled, handleConfirmClick])

  const { Icon, type: dialogType } = useMemo(() => VARIANT_DIALOG[variant], [variant])

  return (
    <Dialog
      open={isOpen}
      icon={Icon}
      type={dialogType}
      subject={description}
      labelApprove={confirmButtonText}
      labelCancel={cancelButtonText}
      onApprove={onApprove}
      onCancel={onCancel}
    />
  )
}

ConfirmationModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  description: PropTypes.string,
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  handleConfirmClick: PropTypes.func,
  isOpen: PropTypes.bool,
  handleDeniedClick: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['info', 'warning']),
}

ConfirmationModal.defaultProps = {
  description: '',
  cancelButtonText: 'Não',
  confirmButtonText: 'Sim',
  handleConfirmClick: () => {},
  handleDeniedClick: undefined,
  isOpen: false,
  disabled: false,
  variant: 'info',
}
export default React.memo(ConfirmationModal)
